import React from 'react';
import { Switch, NavLink } from 'react-router-dom';
import { AppRouter } from '@MASTER';
import { UserProvider } from '@CONTEXTS';
import { useAuthority } from '@HOOKS';
import Delivery from './delivery';
import Returned from './returned';

const Deliveries = () => {
  return (
    <div className="app-definitions">
      <div className="app-content-header">
        <ul className="tab-menu">
          {useAuthority('CREATE_SINGLE_DELIVERY') && (
            <li>
              <NavLink to={`/create/delivery`}>Gönderi Oluştur</NavLink>
            </li>
          )}
          {useAuthority('CREATE_RETURNED_DELIVERY') && (
            <li>
              <NavLink to={`/create/returned`}>
                Randevulu İade Gönderisi Oluştur
              </NavLink>
            </li>
          )}
        </ul>
      </div>
      <div className="nav-page-content">
        <Switch>
          {useAuthority('CREATE_SINGLE_DELIVERY') && (
            <AppRouter
              path={`/create/delivery`}
              component={() => <Delivery />}
              title="Yeni Gönderi Oluştur"
            />
          )}

          {useAuthority('CREATE_RETURNED_DELIVERY') && (
            <AppRouter
              path={`/create/returned`}
              component={() => <Returned />}
              title="Yeni Gönderi Oluştur"
            />
          )}
        </Switch>
      </div>
    </div>
  );
};

export default Deliveries;
